import { render, staticRenderFns } from "./newUserPop.vue?vue&type=template&id=a2f5e498&"
import script from "./newUserPop.vue?vue&type=script&setup=true&lang=js&"
export * from "./newUserPop.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports